/* eslint-disable no-underscore-dangle */
import React from 'react'
import moment from 'moment'
import { Modal, Tag, Button, Divider } from 'antd'
import DOMPurify from 'dompurify'

import * as s from './styles'

const contractColors = {
  CDI: '#108ee9',
  CDD: '#00bcd4',
  STAGE: '#ff5722',
  ALTERNANCE: '#673ab7c7',
  INTERIM: '#87d068',
  default: 'blue',
}

const OfferInformationsModal = (props) => {
  const { isOpen, offer, toggle, apply, primaryColor } = props

  const createMarkup = (html) => ({
    __html: DOMPurify.sanitize(html),
  })

  return (
    <Modal
      visible={isOpen}
      onOk={apply}
      onCancel={toggle}
      width={800}
      footer={null}
      title={null}
    >
      <s.JobDetailWrapper primaryColor={primaryColor}>
        <header className="jobDetailHeaderWrapper">
          <div>
            <h2>
              {offer.displayName || offer.name}
              <Tag color={contractColors[offer.contractType]}>
                {offer.contractType}
              </Tag>
            </h2>
            <p className="location">
              {offer.location || 'Non renseigné'} -{' '}
              <span
                style={{
                  fontSize: '13px',
                  fontWeight: '300',
                  marginBottom: '20px',
                }}
              >
                {moment(offer.createdAt).fromNow()}
              </span>
            </p>
          </div>
          <Button className="apply-btn" onClick={apply}>
            Postuler
          </Button>
        </header>

        <Divider />
        {offer.clientDescription && (
          <div className="description" style={{ marginTop: '50px' }}>
            <h3>Entreprise</h3>
            <div
              className="preview"
              dangerouslySetInnerHTML={createMarkup(offer.clientDescription)}
            />
          </div>
        )}

        {offer.description && (
          <div className="description" style={{ marginTop: '50px' }}>
            <h3>Descriptif du poste</h3>
            <div
              className="preview"
              dangerouslySetInnerHTML={createMarkup(offer.description)}
            />
          </div>
        )}
        {offer.candidateDescription && (
          <div className="description" style={{ marginTop: '50px' }}>
            <h3>Profil recherché</h3>
            <div
              className="preview"
              dangerouslySetInnerHTML={createMarkup(offer.candidateDescription)}
            />
          </div>
        )}
      </s.JobDetailWrapper>
    </Modal>
  )
}

export default OfferInformationsModal
